/**
 * DTOs del catálogo de módulos (`/modules`). Ver docs/FASE-0.md §5 "Módulos".
 */
import { z } from "zod";
import { PATTERNS, WEBHOOK_EVENTS } from "../constants.js";
import { ModuleFeatureSchema, ModuleLimitSchema, ModuleManifestSchema, ModuleRoleSchema } from "../manifest.js";
/** `PUT /modules/:code` valida el cuerpo completo con el manifiesto. */
export const UpsertModuleInputSchema = ModuleManifestSchema;
export const ModuleStatusSchema = z.enum(["active", "hidden", "retired"]);
/**
 * Read-model de un módulo registrado: el manifiesto vigente más `status` y `manifestVersion`,
 * que no forman parte del manifiesto en sí (lo decide el núcleo, no el módulo).
 * No se construye con `ModuleManifestSchema.extend(...)` porque ese schema es un `ZodEffects`
 * (por sus `.refine()`) y no expone `.extend()`.
 */
export const ModuleSchema = z.object({
    code: z.string().regex(PATTERNS.MODULE_CODE),
    name: z.string().min(1).max(80),
    description: z.string().max(400).nullable(),
    baseUrl: z.url(),
    status: ModuleStatusSchema,
    manifestVersion: z.number().int().nonnegative(),
    roles: z.array(ModuleRoleSchema),
    features: z.array(ModuleFeatureSchema),
    limits: z.array(ModuleLimitSchema),
    webhookEvents: z.array(z.enum(WEBHOOK_EVENTS)),
    createdAt: z.iso.datetime(),
    updatedAt: z.iso.datetime(),
});
/**
 * Respuesta de `PUT /modules/:code`: el módulo resultante más avisos de roles/features/límites
 * que desaparecieron del manifiesto entrante pero se conservaron porque siguen en uso (roles en
 * `membership_roles`, features/límites en `plan_features`/`plan_limits`).
 */
export const UpsertModuleResponseSchema = z.object({
    module: ModuleSchema,
    warnings: z.array(z.string()),
});
//# sourceMappingURL=modules.js.map